import { FORM_TYPES } from '../constants'

import defaultState from './defaultState'

const unwrapState = state => state.auth || defaultState

export const getVisible = state => unwrapState(state).visible
export const getSubmitting = state => unwrapState(state).submitting
export const getSubmitted = state => unwrapState(state).submitted
export const getErrors = state => unwrapState(state).errors
export const getResponse = state => unwrapState(state).response
export const getFormType = state => unwrapState(state).formType
export const getFormTag = state => FORM_TYPES[getFormType(state)].formTag
export const getFormTitle = state => FORM_TYPES[getFormType(state)].title
